import { DataQueryKey, UseDataQuery } from '../../../hooks/useDataQuery/dataQuery.types';
import { OmitPaginatedEndpointParams } from '../../types';
import { FindCollectionsListParams, FindOrderCollectionsListParams } from './collections.types';

export const getFindOrderCollectionsListKey = (
  params: FindOrderCollectionsListParams,
): UseDataQuery['queryKey'] => [DataQueryKey.ORDER_COLLECTIONS, undefined, params ?? {}];

export const getFindCollectionsListKey = (
  params: FindCollectionsListParams,
): UseDataQuery['queryKey'] => [DataQueryKey.COLLECTIONS, undefined, params ?? {}];

export const getInfiniteCollectionsListKey = (
  params: OmitPaginatedEndpointParams<FindCollectionsListParams>,
): UseDataQuery['queryKey'] => [DataQueryKey.COLLECTIONS, undefined, params ?? {}];
